import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  pulse?: boolean;
}
export function CTAButton({
  children,
  className = '',
  pulse = false
}: CTAButtonProps) {
  return <motion.a href="tel:8623889571" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-block text-center font-body font-bold uppercase tracking-wider
        px-8 py-4 rounded-md gold-shimmer shadow-lg
        ${pulse ? 'pulse-gold' : ''}
        ${className}
      `} data-id="element-145">
      {children}
    </motion.a>;
}